import { Aperture, Blocks, BookA, BookDown, CalendarCog, ChevronLeft, GalleryHorizontal, Grid2X2, ListTodo, MessageCircleHeart, MonitorPlay, NotepadText, Plus, X } from "lucide-react";

const IconUI =({size,icon})=>{
    
     const Icon=   icon===0?<NotepadText size={size}  color="#90CAF9" />:icon===1?<MonitorPlay size={size}  color="#90CAF9" 
            />:icon===2?<MessageCircleHeart size={size}  color="#90CAF9"  
            />:icon===3?<GalleryHorizontal size={size}   color="#90CAF9"  
            />:icon===4?<MonitorPlay size={size} color="#90CAF9" 
            />:icon===5?
           <Aperture size={size}   color="#90CAF9" />
           :icon===6?<Blocks size={size}  color="#90CAF9" />:icon===7?<CalendarCog size={size}  color="#90CAF9" />
           :icon===8?<X size={size}  color="#90CAF9" />:icon===9?<Plus size={size}  color="#90CAF9" />
    :icon===10?<Grid2X2 size={size}  color="#90CAF9" />:icon===11?<ListTodo size={size}  color="#90CAF9" />
    :icon===12?<ChevronLeft size={size}  color="#90CAF9" />:"";
         
    //  const iconWhite=   icon===0?<BookDown size={size}  color="#fff" />:icon===1?<NotepadText size={size}  color="#fff" 
    //  />:icon===2?<BookA size={size}  color="#fff"  
    //  />:icon===3?<GalleryHorizontal size={size}   color="#fff"  
    //  />:icon===4?<MonitorPlay size={size} color="#fff" 
    //  />:icon===5?
    // <Aperture size={size}   color="#fff" />
    // :icon===6?<Blocks size={size}  color="#fff" />:icon===7?<CalendarCog size={size}  color="#fff" />
    // :icon===8?<X size={size}  color="#fff" />:icon===9?<Plus size={size}  color="#fff" />
    // :icon===10?<Grid2X2 size={size}  color="#fff" />:icon===11?<ListTodo size={size}  color="#fff" />
    // :icon===12?<ChevronLeft size={size}  color="#fff" />:"";
    
    return Icon;
}

export default IconUI;